<template>
  <div>
    <Top />
    <div class="maindiv zcollege-wrap bg-gray">
      <Banner :is-detail="false"/>
      <div class="colleges mt20 bgw htmldiv">
        <BannerTitle />
        <div class="cont zcolleges">
          <SchoolItem v-for="(item,index) in schools" :key="index" :item="item" :index="index"/>
        </div>
      </div>
      <div class="ht30"></div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from "../top";
import Banner from "../banner";
import Bottom from "../bottom";
import SchoolItem from "../school-item";
import BannerTitle from "./ttitle";
export default {
  name: "index",
  data () {
    return {
     'schools':[],
    }
  },
  components:{
    Top,
    Banner,
    Bottom,
    SchoolItem,
    BannerTitle,
  },
  created() {
    var getParam = {};
    getParam['theme'] = 6;
    this.$request.get('school/list',getParam,response => {
      if(response.status == 200){
          this.schools = response.data.data;
        }else{
          alert('暂无更多数据');
        }
    },error => {
      console.log(error);
    })
  }
}
</script>

<style scoped>
  .zcollege-wrap .zcolleges{padding: 80px 0 80px 18px;}
  .zcollege-wrap .zcollege{margin: 0 7px 25px!important;}
</style>



// WEBPACK FOOTER //
// src/components/hedu/school/index.vue